import CustomPagination from './Pagination';

export default CustomPagination;
